const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { Promise } = require('es6-promise');
const { APIGet } = require('utilities/APIRequestHelper');
const { TYPE_FUNDS } = require('constants/index');

function requestIndexes() {
    return {
        type: actionTypes.BROKER_GET_INTERVENERS_REQUEST
    };
}

function requestIndexesSuccess(response, type) {
    return {
        type: actionTypes.BROKER_GET_INTERVENERS_SUCCESS,
        payload: {
            data: response,
            type: type
        }
    };
}

function requestIndexesFailure(response) {
    return {
        type: actionTypes.BROKER_GET_INTERVENERS_FAILURE,
        payload: {
            data: response
        }
    };
}

const getIndexes = (wallet, type) => (dispatch) => {
    return new Promise(function () {
        let requestData,
            url;

        if (type === TYPE_FUNDS) {
            requestData = {
                query: {
                    producto: wallet.getIn(['contrato','producto']),
                    numeroContrato: wallet.getIn(['contrato','numerodecontrato'])
                }
            };
            url = apiURLBuilder.getURL('brokerIntervenersFunds')
        } else {
            requestData = {
                query: {
                    producto: wallet.get('product'),
                    numeroContrato: wallet.get('accountNumber')
                }
            };
            url = apiURLBuilder.getURL('brokerInterveners');
        }

        dispatch(requestIndexes());

        APIGet(dispatch, url , requestData)
            .then(function(response) {
                if (type === TYPE_FUNDS) {
                    dispatch(requestIndexesSuccess(response, TYPE_FUNDS));
                } else {
                     dispatch(requestIndexesSuccess(response));
                }
            }, function(response) {
                dispatch(requestIndexesFailure(response))
            }
        );
    });
}

module.exports = {
    getIndexes
}
